import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IEmailAddress } from 'src/app/models/interfaces/email-address.interface';
import { EmailAddressDetailContext } from '../email-address-detail-context';
import { EmailAddressFormComponent } from '../email-address-form/email-address-form.component';

@Component({
    selector: 'app-email-address-detail',
    templateUrl: './email-address-detail.component.html',
    styleUrls: ['./email-address-detail.component.scss'],
    imports: [MatTabsModule, EmailAddressFormComponent]
})
export class EmailAddressDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public emailAddressUpdated: EventEmitter<IEmailAddress> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: EmailAddressDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<EmailAddressDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: EmailAddressDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param emailAddress: Infos de l'adresse email modifié.
     */
    public onEmailAddressUpdated(emailAddress: IEmailAddress) {
        this.emailAddressUpdated.emit(emailAddress);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
